
class GoogleMap {
    
    constructor() {

      google.maps.event.addDomListener(window, 'load', this.init);
    }

    init() {

      this.mapContainer = document.getElementsByClassName("googlemap");
      this.defaultCenter = [ 45.508888, -73.561668 ];
      this.ZoomDefault   = 13;
      this.styles = [
    {
        "featureType": "administrative",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#a7a7a7"
            }
        ]
    },
    {
        "featureType": "administrative",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#737373"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#efefef"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#dadada"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#696969"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#b3b3b3"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#d6d6d6"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "weight": 1.8
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#d7d7d7"
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "color": "#808080"
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#d3d3d3"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels",
        "stylers": [
            {
                "color": "#848181"
            }
        ]
    }
];

      for( let j=0; j<this.mapContainer.length; j++ ){

        let container = this.mapContainer[j];
        let lang = document.documentElement.lang.substr(0,2);

        let activeMarker = container.getAttribute('data-active') || false;
        let zoomMode = container.getAttribute('data-zoom') || 'default';
        let zoom = this.ZoomDefault;
        
        if (zoomMode == 'medium') zoom = this.ZoomDefault - 1;
        if (zoomMode == 'large') zoom = this.ZoomDefault - 2;

        let mapOptions = {

            center: new google.maps.LatLng(
              container.getAttribute('data-lat') || this.defaultCenter[0],
              container.getAttribute('data-lng') || this.defaultCenter[1]
            ),
            zoom: zoom,
            styles: this.styles,
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: container.hasAttribute('data-compact') ? false : true,
        };

        let map = new google.maps.Map(this.mapContainer[j], mapOptions);
        let infowindow = new google.maps.InfoWindow();

        fetch('/wp-json/napa/v1/markers').then(function (response) {
          if (response.ok) {
            return response.json();
          } else {
            return Promise.reject(response);
          }
        }).then(function (data) {

            const locations = data.result;

            var image = {
              url: '/app/themes/napa/dist/images/location.svg',
              size: new google.maps.Size(30, 38),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(15, 38)
            };
            // Shapes define the clickable region of the icon. The type defines an HTML
            // <area> element 'poly' which traces out a polygon as a series of X,Y points.
            // The final coordinate closes the poly by connecting to the first coordinate.
            var shape = {
              coords: [1, 1, 1, 20, 18, 20, 18, 1],
              type: 'poly'
            };
            for (var i = 0; i < locations.length; i++) {
              var location = locations[i];

              var marker = new google.maps.Marker({
                position: {lat: parseFloat(location.geo_position[0]), lng: parseFloat(location.geo_position[1]) },
                map: map,
                icon: image,
                //shape: shape,
                title: location.centre_name,
                zIndex: i+1
              });

              google.maps.event.addListener(marker, 'click', (function(marker, i) {
                return function() {

                  let body = locations[i]["address"] + '<br>' + locations[i]["city"] + ', ' + locations[i]["province"][lang] + (typeof locations[i]["postalcode"] !== "undefined" ? '<br>' + locations[i]["postalcode"] : "" );
                  let link = '<a href="' + locations[i]["url"][lang] +'" class="button button--small">' + (lang == "fr" ? 'Voir le centre de service' : 'See Service Centre' ) +'</a>';

                  infowindow.setContent(
                    '<div class="googlemap__infowindow"><div class="title">' + locations[i]["centre_name"] + '</div>' +
                    '<div class="body"><p>' + body + '</p>' + link + '</div>'
                    );
                  infowindow.setOptions({maxWidth: 300});
                  infowindow.open(map, marker);
                }
              }) (marker, i));

              // If active marker, open infowindow rightaway
              if (activeMarker && activeMarker == locations[i].geo_position.join() ) {
                new google.maps.event.trigger( marker, 'click' );
              }

            }

        }).catch(function (err) {
          console.warn('Could not fetch markers.', err);
        });


      }

    }

}

export default GoogleMap;






// WEBPACK FOOTER //
// ./scripts/components/googlemap.js